import request from "@/utils/request";

export async function getUnitList(payload) {
 
  return request.get("Unit/List", {
    params: {
      name: payload.unit,
      originUnitQuantity: payload.unitOriginQuantity,
      originUnitName: payload.unitOrigin,
      shortName: payload.unitShortName,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}
export async function createNewUnit(newUnit) {
  return request.post("Unit/Create", newUnit);
}
export async function updateUnit(unit) {
  return request.post("Unit/Update", unit);
}
export async function deleteUnit(id) {
  return request.delete('Unit/Delete?id=' + id);
}
export async function getUnitNameList() {
  return request.get("Unit/NameList");
}
export async function getAlternateUnits(id) {
  return request.get("Unit/FullAlternateList",{params:{
      originUnitId : id
    }});
}
export async function findRateBetweenUnits(selectedUnitId, toUnitId) {
  return request.get("Unit/FindRateBetweenUnits?selectedUnitId=" + selectedUnitId + "&toUnitId=" + toUnitId);
}
export async function findRateToRoot(selectedUnitId) {
  return request.get("Unit/FindRateToRoot?selectedUnitId=" + selectedUnitId);
}
export async function getRootUnit(unitId) {
  return request.get("Unit/GetRoot?unitId=" + unitId)
}

export async function getFullAlternateList(originUnitId){
  return request.get("Unit/FullAlternateList",{params:{
    originUnitId : originUnitId
    }});
}

export async function convertUnit(unitId,stockId)
{
  return request.get("Unit/ConvertUnit",{params:{
    unitId:unitId,
    stockId:stockId
    }});
}
